import * as types from "./actionType";

const initialState = {
  allUserStatus: false,
  allUser: [],
  allEvents: [],
  allEventsStatus: false,
  singleEvent: null,
  singleEventStatus: false,
  createEventStatus: false,
  deleteEventStatus: false,
  updateEventStatus: false,
  countryStatus: false,
  countries: [],
  stateStatus: false,
  states: [],
  cityStatus: false,
  cities: [],
  eventForModerationStatus: false,
  eventForModeration: [],
  moderationStatusOfEvent: false,
  usersToJoinEventStatus: false,
  usersToJoinEvent: [],
  moderationStatusForUser: false,
  joinNewUserStatus: false,
  eventImagesForModerationStatus: false,
  eventImagesForModeration: [],
  moderateImageStatus: false,
  moderateEventGalleryStatus: false,
};

function eventReducers(state = initialState, action) {
  switch (action.type) {
    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        ...state,
        allUserStatus: false,
        allUser: [],
        
      };
    case types.FETCH_ALL_EVENT:
      return {
        ...state,
        allEvents: [],
        allEventsStatus: true,
      };

    case types.FETCH_ALL_EVENT_SUCCESS: {
      return {
        ...state,
        allEvents: action.payload,
        allEventsStatus: false,
      };
    }
    case types.FETCH_ALL_EVENT_FAILED: {
      return {
        ...state,
        allEvents: [],
        allEventsStatus: false,
      };
    }

    case types.FETCH_SINGLE_EVENT:
      return {
        ...state,
        singleEvent: null,
        singleEventStatus: true,
      };

    case types.FETCH_SINGLE_EVENT_SUCCESS: {
      return {
        ...state,
        singleEvent: action.payload,
        singleEventStatus: false,
      };
    }
    case types.FETCH_SINGLE_EVENT_FAILED: {
      return {
        ...state,
        singleEvent: null,
        singleEventStatus: false,
      };
    }

    case types.FETCH_COUNTRY:
      return {
        ...state,
        countryStatus: true,
        countries: [],
      };
    case types.FETCH_COUNTRY_SUCCESS: {
      return {
        ...state,
        countryStatus: false,
        countries: action.payload,
      };
    }
    case types.FETCH_COUNTRY_FAILED: {
      return {
        ...state,
        countryStatus: false,
        countries: [],
      };
    }

    case types.FETCH_STATE:
      return {
        ...state,
        stateStatus: true,
        states: [],
      };
    case types.FETCH_STATE_SUCCESS: {
      return {
        ...state,
        stateStatus: false,
        states: action.payload,
      };
    }
    case types.FETCH_STATE_FAILED: {
      return {
        ...state,
        stateStatus: false,
        states: [],
      };
    }

    case types.FETCH_CITY:
      return {
        ...state,
        cityStatus: true,
        cities: [],
      };
    case types.FETCH_CITY_SUCCESS: {
      return {
        ...state,
        cityStatus: false,
        cities: action.payload,
      };
    }
    case types.FETCH_CITY_FAILED: {
      return {
        ...state,
        cityStatus: false,
        cities: [],
      };
    }

    case types.CREATE_EVENT:
      return {
        ...state,
        createEventStatus: true,
      };

    case types.CREATE_EVENT_SUCCESS: {
      return {
        ...state,
        createEventStatus: false,
      };
    }

    case types.CREATE_EVENT_FAILED: {
      return {
        ...state,
        createEventStatus: false,
      };
    }

    case types.UPDATE_EVENT:
      return {
        ...state,
        updateEventStatus: true,
      };

    case types.UPDATE_EVENT_SUCCESS: {
      return {
        ...state,
        updateEventStatus: false,
      };
    }

    case types.UPDATE_EVENT_FAILED: {
      return {
        ...state,
        updateEventStatus: false,
      };
    }

    case types.DELETE_EVENT:
      return {
        ...state,
        deleteEventStatus: true,
      };

    case types.DELETE_EVENT_SUCCESS: {
      return {
        ...state,
        deleteEventStatus: false,
      };
    }

    case types.DELETE_EVENT_FAILED: {
      return {
        ...state,
        deleteEventStatus: false,
      };
    }

    case types.MODERATION_OF_EVENT:
      return {
        ...state,
        moderationStatusOfEvent: true,
      };

    case types.MODERATION_OF_EVENT_SUCCESS: {
      return {
        ...state,
        moderationStatusOfEvent: false,
      };
    }

    case types.MODERATION_OF_EVENT_FAILED: {
      return {
        ...state,
        moderationStatusOfEvent: false,
      };
    }
    case types.FETCH_EVENT_FOR_MODERATION:
      return {
        ...state,
        eventForModerationStatus: true,
        eventForModeration: [],
      };
    case types.FETCH_EVENT_FOR_MODERATION_SUCCESS: {
      return {
        ...state,
        eventForModerationStatus: false,
        eventForModeration: action.payload,
      };
    }
    case types.FETCH_EVENT_FOR_MODERATION_FAILED: {
      return {
        ...state,
        eventForModerationStatus: false,
        eventForModeration: [],
      };
    }

    case types.FETCH_USER_TO_JOIN_EVENT:
      return {
        ...state,
        usersToJoinEventStatus: true,
        usersToJoinEvent: [],
      };
    case types.FETCH_USER_TO_JOIN_EVENT_SUCCESS: {
      return {
        ...state,
        usersToJoinEventStatus: false,
        usersToJoinEvent: action.payload,
      };
    }
    case types.FETCH_USER_TO_JOIN_EVENT_FAILED: {
      return {
        ...state,
        usersToJoinEventStatus: false,
        usersToJoinEvent: [],
      };
    }

    case types.FETCH_ALL_USERS:
      return {
        ...state,
        allUserStatus: true,
        allUser: [],
      };
    case types.FETCH_ALL_USERS_SUCCESS: {
      return {
        ...state,
        allUserStatus: false,
        allUser: action.payload,
      };
    }
    case types.FETCH_ALL_USERS_FAILED: {
      return {
        ...state,
        allUserStatus: false,
        allUser: [],
      };
    }

    case types.MODERATION_FOR_USER_EVENT:
      return {
        ...state,
        moderationStatusForUser: true,
      };
    case types.MODERATION_FOR_USER_EVENT_SUCCESS: {
      return {
        ...state,
        moderationStatusForUser: false,
      };
    }
    case types.MODERATION_FOR_USER_EVENT_FAILED: {
      return {
        ...state,
        moderationStatusForUser: false,
      };
    }

    case types.JOIN_NEW_USER:
      return {
        ...state,
        joinNewUserStatus: true,
      };
    case types.JOIN_NEW_USER_SUCCESS: {
      return {
        ...state,
        joinNewUserStatus: false,
      };
    }
    case types.JOIN_NEW_USER_FAILED: {
      return {
        ...state,
        joinNewUserStatus: false,
      };
    }
    case types.FETCH_IMAGES_FOR_MODERATION:
      return {
        ...state,
        eventImagesForModerationStatus: true,
        eventImagesForModeration: [],
      };
    case types.FETCH_IMAGES_FOR_MODERATION_SUCCESS: {
      return {
        ...state,
        eventImagesForModerationStatus: false,
        eventImagesForModeration: action.payload,
      };
    }
    case types.FETCH_IMAGES_FOR_MODERATION_FAILED: {
      return {
        ...state,
        eventImagesForModerationStatus: false,
        eventImagesForModeration: [],
      };
    }
    case types.MODERATED_IMAGES:
      return {
        ...state,
        moderateImageStatus: true,
      };
    case types.MODERATED_IMAGES_SUCCESS: {
      return {
        ...state,
        moderateImageStatus: false,
      };
    }
    case types.MODERATED_IMAGES_FAILED: {
      return {
        ...state,
        moderateImageStatus: false,
      };
    }

    case types.UPDATE_EVENT_BY_ADMIN:
      return {
        ...state,
        updateEventStatus: true,
      };

    case types.UPDATE_EVENT_BY_ADMIN_SUCCESS: {
      return {
        ...state,
        updateEventStatus: false,
      };
    }

    case types.UPDATE_EVENT_BY_ADMIN_FAILED: {
      return {
        ...state,
        updateEventStatus: false,
      };
    }

    case types.MODERATION_OF_EVENT_GALLERY:
      return {
        ...state,
        moderateEventGalleryStatus: true,
      };

    case types.MODERATION_OF_EVENT_GALLERY_SUCCESS: {
      return {
        ...state,
        moderateEventGalleryStatus: false,
      };
    }

    case types.MODERATION_OF_EVENT_GALLERY_FAILED: {
      return {
        ...state,
        moderateEventGalleryStatus: false,
      };
    }
    default:
      return state;
  }
}

export default eventReducers;
